//libraries
import Vue from 'vue'
import _ from "lodash"

let resource = 'group'
let resource_name = 'grupo'
let resource_name_plural = 'grupos'

let state = {
  cases: {},
  group: {},
  total: 0,
  sortType: 'DESC'
}

const SORT_TYPES = {
  NONE: 'NONE',
  ASC: 'ASC',
  DESC: 'DESC'
}

state[resource + 's'] = []

//functions receive state
let getters = {
  total_cases (state) {
    return state.total
  },
  groups (state) {
    return state.groups
  },
  getCases({ cases, sortType }) {
    return Object.values(cases)
    if (sortType === SORT_TYPES.NONE) return Object.values(cases)

    return Object.values(cases).sort((a, b) => {
      let { last_message_time: aDate, updatedAt: updateDateA } = a
      let { last_message_time: bDate, updatedAt: updateDateB } = b

      if (aDate && bDate) {
        aDate = new Date(aDate)
        bDate = new Date(bDate)

        return sortType === SORT_TYPES.ASC ? aDate - bDate : bDate - aDate
      }

      updateDateA = new Date(updateDateA)
      updateDateB = new Date(updateDateB)

      return sortType === SORT_TYPES.ASC ? updateDateA - updateDateB : updateDateB - updateDateA
    })
  }
}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      const {update_state = true} = params
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if (res.data.success) {
        if (update_state) {
          for (let item of res.data.resource) {
            item.open = false
            item.openCasesCount = 0
            item.onHoldCasesCount = 0
          }
          commit('setItems', res.data.resource)
        }
        if (params.callback) params.callback(res.data)
      } else {
        if (params.callback) params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      commit('setGroup', {})
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setGroup', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async cases ({ commit }, params) {
    try {
      if(params.params.page == 1) commit('setCases', [])
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/cases`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('concatCases', res.data.resource)
        commit('setTotal', res.data.total)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async admins ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/admins`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo admins del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo admins del ${resource_name}.`})
      console.error(e)
    }
  },
  async countCases ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/count_cases`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo cuenta del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuenta del ${resource_name}.`})
      console.error(e)
    }
  },
  async countCasesByGroups ({ commit }, params) {
    try {
      if(!params.account_id) return;
      let res = await Vue.request.get(`account/${params.account_id}/countCasesByGroups`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo cuenta del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuenta del ${resource_name}.`})
      console.error(e)
    }
  },
  clearCases ({ commit }, params) {
    commit('setCases', [])
    commit('setTotal', 0)
  },
  async countUnreadCases ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/count_unread_cases`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo cuenta del ${resource_name} sin leer.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuenta del ${resource_name} sin leer.`})
      console.error(e)
    }
  },
}

const addCase = (state, item) => {
  if (!item.case_id) return

  const aux = JSON.parse(JSON.stringify(state.cases))
  aux[item.case_id] = item

  state.cases = aux
  state.total = Object.keys(state.cases).length
}

//functions receive state
const mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  setCases(state, items) {
    state.cases = items.reduce((acc, curr) => {
      if (!curr) return acc
      return {
        ...acc,
        [curr.case_id]: curr
      }
    }, {})

    state.total = Object.keys(state.cases).length
  },
  setTotal (state, total) {
    state.total = total
  },
  concatCases(state, items) {
    const totalItems = [...items, ...Object.values(state.cases)]

    state.cases = totalItems.reduce((acc, curr) => {
      if (!curr.case_id) return acc

      return { ...acc, [curr.case_id]: curr }
    }, {})
    //state.total = Object.keys(state.cases).length
  },
  setGroup (state, item) {
    state.group = item
  },
  pushCase(state, item) {
    addCase(state, item)
  },
  addCase (state, item) {
    addCase(state, item)
  },
  updateCase (state, item) {
    addCase(state, item)
  },
  updateCaseData (state, data) {
    const skCase = state.cases[data.case_id]

    if (!skCase) return

    skCase[data.key] = data.value
  },
  removeCase (state, item) {
    try {
      const aux = JSON.parse(JSON.stringify(state.cases))
      delete aux[item.case_id]

      state.cases = aux
      state.total = Object.keys(state.cases).length
    } catch (e) {
      console.error(e)
    }
  },
  updateSortType(state, item) {
    state.sortType = item
  },
  setCaseTags(state, item) {
    setTimeout(() => {
      if (state.cases[item.case_id]) state.cases[item.case_id] = item
    }, 500)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
